import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import { paths } from 'routes';
import { useAuth } from 'lib/auth';
import { ConfirmationSentForm } from '../components/ConfirmationSentForm';
import { LoginForm } from '../components/LoginForm';
import { RequestAccessForm } from '../components/RequestAccessForm';
import { Error } from './Error';
import { Loader } from 'components/Loader';
import { membershipIdForVat } from '../api/register';

export const FinishRegistrationForm = ({ values }) => {
  const { t } = useTranslation();
  const [turnstileToken, setTurnstileToken] = useState(''); // Added
  const [ data, setData ] = useState({});
  const initialLoad = useRef(true);
  const { checkExistance, register, refreshSession } = useAuth();
  const [ loading, setLoading ] = useState(true);
  const [ error, setError ] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const verify = async () => {      
      try {
        const vat = `SE${values.vat}01`;
        const result = await checkExistance(values.companyEmail, vat);
        setData(result);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    }

    if (initialLoad.current) {
      verify();
      initialLoad.current = false;
    }
  }, [])

  const { account_exists: accountExists, company_exists: companyExists, company_is_shadow: isShadow } = data;

  const continueExistingAccount = async (response) => {
    const memberID = membershipIdForVat(response?.data, values.vat);
    if (memberID) {
      await refreshSession(memberID);
      navigate(paths.homepage);
    } else if (isShadow) {
      const registered = await register(values, false);
      await refreshSession(membershipIdForVat(registered?.data, values.vat));
      navigate(paths.homepage);
    } else {
      navigate(paths.requestAccess, { state: { values } });
    }
  };

  return (
    <>
    {loading && (
      <Box height={452} sx={{alignContent: "center", mb: 5}}>
        <Loader />
      </Box>
    )}
    {!loading && (
    <>
      {error && (
        <Error />
      )}
      {!error && (
        <>
        {/* No login and no company - create everything and send confirmation email */}
        {!accountExists && !companyExists && (
          <ConfirmationSentForm
            values={ values }
            onTurnstileVerify={setTurnstileToken} // Added prop
            turnstileToken={turnstileToken} // Added prop
          />
        )}
        {/* Login exists, new company - log in, then create the company */}
        {accountExists && !companyExists && (
          <LoginForm
            values={ values }
            registrationFlow={ true }
            onSuccess={() => navigate(paths.homepage)}
            msg={t('website:auth.login.messages.newUser')}
          />
        )}
        {/* Login and company exist - log in, then continue as member, claim the shadow company or request access */}
        {accountExists && companyExists && (
          <LoginForm
            values={ values }
            registrationFlow={ true }
            existingUser={ true }
            onSuccess={ continueExistingAccount }
            msg={t('website:auth.login.messages.existingUser')}
          />
        )}
        {/* No login, company exists - claim a shadow company, otherwise request access */}
        {!accountExists && companyExists && (
          <>
          {isShadow ? (
            <ConfirmationSentForm values={ values } />
          ):
          (
            <RequestAccessForm values={ values } createFirebaseUser={ true } />
          )}
          </>
        )}
        {/* Company exists, no User and email domain is different than from admin - Company exists form opened. Return to home action */}
      {/*  {!loading && Company && !User && !SameDomain && (
          <CompanyExistsForm
            values={ values }
          />
        )} */}
        </>
      )}
    </>
    )}
    </>
  );
};
